module.exports = __webpack_public_path__ + "static/NOOBZOO_BANNER-33916121f791cea0beb7be731e82276f.png";